import ready from "../utils/ready";
import { $, $$ } from "../utils/selector";

import Swiper from 'swiper';

ready(() => {
  console.log('Homepage');

  var swiper = new Swiper('.swiper-container', {
    // spaceBetween: 30,

    loop: true,
    effect: 'fade',
    speed: 750,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  /*
  var mySwiper = new Swiper ('.swiper-container', {
    // Optional parameters
    // direction: 'vertical',
    loop: true,
    effect: 'fade',
    speed: 750,
    fadeEffect: {
      crossFade: true
    },

    // If we need pagination
    pagination: {
      el: '.slideshow-pagination',
      type: 'fraction',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.slideshow-button-next',
      prevEl: '.slideshow-button-prev',
    },

    // And if we need scrollbar
    //scrollbar: {
    //  el: '.swiper-scrollbar',
    //},
  })
  */
});
